(function () {
  var STANDOFF_PROPERTY = 'acrylic standoffs for wall mounting';

  function getStandoffSize(variant) {
    if (!variant || !Array.isArray(variant.options)) return '';

    return variant.options.find(function (option) {
      var normalized = String(option)
        .toLowerCase()
        .replace(/\u00d7/g, 'x')
        .replace(/inches|inch|in|"/g, '')
        .replace(/\s+/g, '');

      return normalized === '40x60' || normalized === '60x40';
    }) || '';
  }

  function initializeStandoffFeature(root) {
    if (!root || root.dataset.acStandoffReady === 'true') return;

    var form = root.querySelector('.js-main-product-form');
    var variantsData = root.querySelector('[data-ac-standoff-variants]');
    var notice = root.querySelector('[data-ac-standoff-notice]');
    var noticeSize = root.querySelector('[data-ac-standoff-size]');
    var propertyInput = root.querySelector('[data-ac-standoff-property]');
    var customMedia = root.querySelector('[data-ac-standoff-media]');
    var customThumb = root.querySelector('[data-ac-standoff-thumb]');

    if (!form || !variantsData || !notice || !propertyInput || !customMedia) return;

    var variants;
    try {
      variants = JSON.parse(variantsData.textContent);
    } catch (error) {
      return;
    }

    root.dataset.acStandoffReady = 'true';

    function showCustomMedia() {
      customMedia.classList.remove('d-none');

      if (customThumb) {
        customThumb.classList.remove('d-none');
        root.querySelectorAll('.js-product-slideshow-thumb').forEach(function (thumb) {
          thumb.classList.toggle('is-active-item', thumb === customThumb);
        });
      }

      var isMobile = window.matchMedia('(max-width: 768px)').matches;
      var slideshow = root.querySelector('ecx-prd-slideshow');

      if (isMobile) {
        var carouselItems = root.querySelector('ecx-carousel[data-section-id] .js-carousel-items');
        requestAnimationFrame(function () {
          if (carouselItems) {
            carouselItems.scrollTo({ left: customMedia.offsetLeft, behavior: 'smooth' });
          }
        });
      } else if (slideshow) {
        slideshow.querySelectorAll('.js-product-slideshow-item').forEach(function (item) {
          item.classList.remove('d-block');
          if (item !== customMedia) item.classList.add('d-none');
        });
        customMedia.classList.remove('d-none');
        customMedia.classList.add('d-block');
      }

      if (customThumb) {
        var thumbScroller = customThumb.closest('.js-carousel-items');
        if (thumbScroller) {
          thumbScroller.scrollTo({ left: customThumb.offsetLeft, top: customThumb.offsetTop, behavior: 'smooth' });
        }
      }

      window.dispatchEvent(new Event('resize'));
    }

    function hideCustomMedia() {
      customMedia.classList.remove('d-block');
      customMedia.classList.add('d-none');
      if (customThumb) {
        customThumb.classList.remove('is-active-item');
        customThumb.classList.add('d-none');
      }

      if (!window.matchMedia('(max-width: 768px)').matches) {
        var visibleNativeMedia = root.querySelector('.js-product-slideshow-item:not([data-ac-standoff-media]).d-block');
        if (!visibleNativeMedia) {
          var firstNativeMedia = root.querySelector('.js-product-slideshow-item:not([data-ac-standoff-media])');
          if (firstNativeMedia) {
            firstNativeMedia.classList.remove('d-none');
            firstNativeMedia.classList.add('d-block');
          }
        }
      }
    }

    function syncFromVariantId() {
      var variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return;

      var variant = variants.find(function (item) {
        return String(item.id) === String(variantInput.value);
      });
      var size = getStandoffSize(variant);
      var isStandoffVariant = size !== '';

      notice.hidden = !isStandoffVariant;
      if (noticeSize) noticeSize.textContent = size;

      propertyInput.disabled = !isStandoffVariant;
      propertyInput.value = isStandoffVariant ? STANDOFF_PROPERTY : '';

      if (isStandoffVariant) {
        showCustomMedia();
      } else {
        hideCustomMedia();
      }
    }

    form.addEventListener('change', function (event) {
      if (event.target && event.target.name === 'id') {
        setTimeout(syncFromVariantId, 0);
      }
    });

    syncFromVariantId();
  }

  function initializeAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('.main-product[data-ui-component="Main Product Section"]')) {
      initializeStandoffFeature(context);
    }
    context.querySelectorAll('.main-product[data-ui-component="Main Product Section"]').forEach(initializeStandoffFeature);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
